const EditGrowthSpecial = () => import('../modules/xmsb/energy/operators/EditGrowthSpecialGzl')

export default [
  {

    path: '/growthspecialedit',
    name: 'growthspecialedit',
    component: EditGrowthSpecial,
    meta: {
      title: '2019年“三位一体”专项资金大企业大集团培育新增长点企业项目申请编辑',
      fullscreen: true,
    },
  },
]
